import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import EnhancedCDD from "./EnhancedCDD";
import SimplifiedCDD from "./SimplifiedCDD";

const tabsKey = [
  {
    name: "Simplified",
    tabName: "simplified",
    value: 1,
  },
  {
    name: "Enhanced",
    tabName: "enhanced",
    value: 2,
  },
];

const OngoingCDD = ({ readAccess, writeAccess }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("subChildTab") || "simplified";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  useEffect(() => {
    navigate(
      `?tab=cdd&childTab=ongoing&subChildTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={"p-0 border-none bg-transparent"}
        >
          {activeTab === 1 ? (
            <SimplifiedCDD
              sectionType={"1"}
              readAccess={readAccess}
              writeAccess={writeAccess}
            />
          ) : activeTab === 2 ? (
            <EnhancedCDD
              sectionType={"1"}
              readAccess={readAccess}
              writeAccess={writeAccess}
            />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default OngoingCDD;
